import { useEffect, useState } from 'react';
import AppStoreIcon from '../assets/images/store/appstore.png';
import PlayStoreIcon from '../assets/images/store/playstore.png';
import Logo from '../assets/images/icon.png';
import { useSite } from '../context/SiteContext';

export default function DownloadPopup() {
  const { settings } = useSite();
  // 1. Add local state to control visibility
  const [isOpen, setIsOpen] = useState(false);

  const appStoreUrl = (!settings?.app_store_url || settings.app_store_url.includes('id123456789'))
    ? "https://apps.apple.com/us/app/wayabank/id1658552439"
    : settings.app_store_url;

  const playStoreUrl = (!settings?.play_store_url || settings.play_store_url.includes('com.wayabank.app'))
    ? "https://play.google.com/store/apps/details?id=ng.wayabank"
    : settings.play_store_url;

  // 2. Listen for the custom event
  useEffect(() => {
    const openPopup = () => setIsOpen(true);

    window.addEventListener('waya-open-download-popup', openPopup);

    return () => {
      window.removeEventListener('waya-open-download-popup', openPopup);
    };
  }, []);

  // 3. Create a close handler
  const handleClose = () => setIsOpen(false);

  if (!isOpen) return null;

  // 4. Use handleClose instead of onClose for your click events
  return (
    <div className="waya-popup-overlay" onClick={handleClose}>
      <div className="waya-popup-card" onClick={(e) => e.stopPropagation()}>
        <button className="waya-popup-close" onClick={handleClose}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <img src={Logo} alt="WayaBank" className="waya-popup-logo" />

        <h3 className="waya-popup-title">WayaBank is mobile-only</h3>
        <p className="waya-popup-desc">
          To ensure the highest level of security and provide the best
          experience, WayaBank is exclusively available on mobile. Download the
          app to get started.
        </p>

        <div className="waya-popup-stores">
          <a
            href={appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="waya-store-link"
          >
            <img
              src={AppStoreIcon}
              alt="App Store"
              style={{ height: '32px' }}
            />
            <div className="text-left">
              <div style={{ fontSize: '10px', opacity: 0.8 }}>
                Download on the
              </div>
              <div style={{ fontWeight: '600' }}>App Store</div>
            </div>
          </a>

          <a
            href={playStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="waya-store-link"
          >
            <img
              src={PlayStoreIcon}
              alt="Play Store"
              style={{ height: '32px' }}
            />
            <div className="text-left">
              <div style={{ fontSize: '10px', opacity: 0.8 }}>Get it on</div>
              <div style={{ fontWeight: '600' }}>Google Play</div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}
